(function () {
  var form = document.getElementById('IntoventContactForm');
  if (!form) return;

  // Postal code -> address auto-fill (prefecture + city only; town name onward is manual)
  var postalInput = form.querySelector('#IntoventContactForm-postal');
  var addressInput = form.querySelector('#IntoventContactForm-address');

  function lookupAddress() {
    if (!postalInput || !addressInput) return;
    var digits = postalInput.value.replace(/[^0-9]/g, '');
    if (digits.length !== 7) return;

    fetch('https://zipcloud.ibsnet.co.jp/api/search?zipcode=' + digits)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (!data || !data.results || !data.results.length) return;
        var result = data.results[0];
        var prefectureAndCity = (result.address1 || '') + (result.address2 || '');
        if (prefectureAndCity && addressInput.value === '') {
          addressInput.value = prefectureAndCity;
        }
      })
      .catch(function () {
        /* Silently ignore lookup failures; the customer can still type their address manually. */
      });
  }

  if (postalInput) {
    postalInput.addEventListener('blur', lookupAddress);
    postalInput.addEventListener('input', function () {
      var digits = postalInput.value.replace(/[^0-9]/g, '');
      if (digits.length === 7) lookupAddress();
    });
  }

  // Email confirmation match check
  var emailInput = form.querySelector('#IntoventContactForm-email');
  var emailConfirmInput = form.querySelector('#IntoventContactForm-email-confirm');
  var emailConfirmError = form.querySelector('#IntoventContactForm-email-confirm-error');

  function checkEmailsMatch() {
    if (!emailInput || !emailConfirmInput) return true;
    var matches = emailInput.value === emailConfirmInput.value;
    emailConfirmInput.setCustomValidity(matches ? '' : 'メールアドレスが一致しません');
    if (emailConfirmError) {
      emailConfirmError.hidden = matches || emailConfirmInput.value === '';
    }
    return matches;
  }

  if (emailInput && emailConfirmInput) {
    emailInput.addEventListener('input', checkEmailsMatch);
    emailConfirmInput.addEventListener('input', checkEmailsMatch);
  }

  form.addEventListener('submit', function (event) {
    if (!checkEmailsMatch()) {
      event.preventDefault();
      if (emailConfirmInput) emailConfirmInput.focus();
    }
  });
})();
